<template>
  <div class="modal-overlay">
    <div class="modal-content" style="max-width: 60vw">
      <div class="modal-header">
        <h5 style="color: white" class="modal-title">Add New Expense</h5>
        <button type="button" class="close" @click="closeModal">&times;</button>
      </div>
      <div
        v-if="loading"
        style="
          display: flex;
          align-items: center;
          justify-content: center;
          height: 200px;
          font-size: 1.25rem;
          font-weight: 600;
          color: #555;
        "
        class="modal-body"
      >
        Loading...
      </div>
      <div v-if="!loading" class="modal-body">
        <form @submit.prevent="submitExpense">
          <div class="form-grid">
            <div class="form-group">
              <label>Expense Title</label>
              <input type="text" v-model="expense.expense_title" required />
            </div>

            <div class="form-group">
              <label>Amount</label>
              <input type="number" v-model="expense.amount" required />
            </div>

            <div class="form-group">
              <label>Expense Date</label>
              <input type="date" v-model="expense.expense_date" required />
            </div>

            <div class="form-group">
              <label>Category</label>
              <select v-model="expense.expense_area_id" required>
                <option disabled value="">Select Category</option>
                <option v-for="cat in categories" :key="cat.id" :value="cat.id">
                  {{ cat.name }}
                </option>
              </select>
            </div>

            <div class="form-group">
              <label>Payment Method</label>
              <select v-model="expense.payment_method" required>
                <option disabled value="">Select payment method</option>
                <option value="1">Cash</option>
                <option value="3">Mpesa</option>
                <option value="2">Card</option>
              </select>
            </div>

            <div class="form-group full">
              <label>Description</label>
              <textarea v-model="expense.description" rows="3"></textarea>
            </div>
          </div>

          <div class="modal-footer">
            <button type="button" class="cancel-btn" @click="closeModal">
              Cancel
            </button>
            <button type="submit" class="save-btn">Save Expense</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { generalApiRequest } from "../../../api/apiIndex";
export default {
  name: "AddExpenseModal",
  props: {},
  data() {
    return {
      loading: true,
      categories: [],
      expense: {
        expense_title: "",
        amount: "",
        expense_date: new Date().toISOString().substr(0, 10),
        expense_area_id: "",
        payment_method: "",
        description: "",
      },
    };
  },
  methods: {
    closeModal() {
      this.$emit("close-add-expense-modal");
    },
    async fetch_expense_categories() {
      this.loading = true;
      var req_body = {};
      const url = `finance/fetch_expense_categories`;
      const res = await generalApiRequest(url, "GET", req_body, 1);
    //   console.log(res);

      this.categories = res.data;
      this.loading = false;
    },
    async submitExpense() {
      this.loading = true;
      var req_body = this.expense;
      const url = `finance/storeExpense`;
      const res = await generalApiRequest(url, "POST", req_body, 1);
      this.categories = res.data;
      this.loading = false;
      this.closeModal();
    },
  },
  mounted() {
    this.fetch_expense_categories();
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(31, 31, 31, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

.modal-content {
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  width: 100%;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
}

.modal-header {
  background: #1d3557;
  color: #fff;
  padding: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-title {
  margin: 0;
}

.close {
  background: #e63946;
  border: none;
  color: #fff;
  font-size: 1.5rem;
  cursor: pointer;
  padding: 0 0.5rem;
}

.modal-body {
  padding: 1rem;
  overflow-y: auto;
  flex-grow: 1;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-group.full {
  grid-column: span 2;
}

.form-group label {
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.form-group input,
.form-group select,
.form-group textarea {
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  padding: 1rem;
  border-top: 1px solid #ddd;
}

.cancel-btn {
  background: #adb5bd;
  color: #fff;
  border: none;
  padding: 0.5rem 1.25rem;
  border-radius: 4px;
  cursor: pointer;
}

.save-btn {
  background: #1d3557;
  color: #fff;
  border: none;
  padding: 0.5rem 1.25rem;
  border-radius: 4px;
  cursor: pointer;
}
</style>
